import { useEffect, useState } from "react";
import {
  useBackProduct,
  useGetMyProductList,
} from "../../../../hooks/useContent";
import { Container } from "../../../../theme/GlobalStyle";
import { sumPrice } from "../../../../utils/sumPrice";
import Button from "../../../Button/Button";
import { Table } from "../../../Table/Table";
import { AiOutlineRollback } from "react-icons/ai";
import { useQueryClient } from "react-query";
import { RenderTooltip } from "../../../Tooltip/Tooltip";
import Loading from "../../../Loadings/LoadingTable";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";

const SubmitPorduct = () => {
  const headerTitle = [
    "#",
    "عنوان محصول",
    "دسته بندی",
    "قیمت یک عدد",
    "تعداد در جین",
    "قیمت کل",
    "برند",
    "تعداد موجودی",
    "کد محصول",
    "عملیات",
  ];
  const queryClient = useQueryClient();
  // const [PageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");
  const {
    data: listProduct,
    isLoading: loadingProduct,
    hasNextPage,
    fetchNextPage,
  } = useGetMyProductList(search, {
    status: "Back",
  });

  const pageCount = listProduct?.pages[0]?.data?.count;

  // handle back product

  const { mutateAsync: goBackProduct } = useBackProduct();

  const handleBack = async (productId) => {
    const data = {
      StatusProducts: "Barci",
      IdProducts: productId,
    };
    await goBackProduct(data);
    queryClient.invalidateQueries("fetch-myProduct-list", 1, "Back");
  };

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);

  let i = 0;

  const items = listProduct ? (
    listProduct?.pages?.map((page) =>
      page?.data?.Products?.map((item) => (
        <tr key={item.IdProducts}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {(i += 1)}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.NameProducts}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.first_category?.NameCategories}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.PriceProducts}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.NumberInJeans}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {sumPrice(
                item?.NumberSellProducts,
                item?.NumberInJeans,
                item?.PriceProducts
              )}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.brand?.NameBrands}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.NumberInStock}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.CodeProducts}
            </span>
          </td>

          <td>
            <RenderTooltip title="برگشت محصول">
              <Button
                small="40px"
                bgColor="#FFC107"
                size="12px"
                color="#fff"
                onclick={() => handleBack(item?.IdProducts)}
              >
                <AiOutlineRollback size={20} />
              </Button>
            </RenderTooltip>
          </td>
        </tr>
      ))
    )
  ) : (
    <Loading />
  );

  if (loadingProduct) {
    return <Loading />;
  }

  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="محصولات"
        num3="محصولات تایید نشده"
        href1="/dashboard/content-controller"
        href2="/dashboard/content-controller/products"
      />
      <Container>
        <Table
          setSearch={setSearch}
          items={items}
          headerTitle={headerTitle}
          title={`لیست محصولات تایید نشده (${pageCount || ""})`}
        />
      </Container>
    </>
  );
};

export default SubmitPorduct;
